import {
  AddOutlined,
  AddShoppingCartOutlined,
  RemoveOutlined,
  ShoppingCart,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import { Button, IconButton, Stack } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./Cart.css";

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */

/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} productId - Unique ID for the product
 */

/**
 * Returns the complete data on all products in cartData by searching in productsData
 *
 * @param { Array.<{ productId: String, qty: Number }> } cartData
 *    Array of objects with productId and quantity of products in cart
 * 
 * @param { Array.<Product> } productsData
 *    Array of objects with complete data on all available products
 *
 * @returns { Array.<CartItem> }
 *    Array of objects with complete data on products in cart
 *
 */


export const generateCartItemsFrom = (cartData, productsData) => {
  // console.log(cartData)
  // console.log(productsData)
  if (!cartData)
    return;
  
  const myCart = cartData.map((item) => ({
    ...item,
    ...productsData.find((product) => item.productId === product._id),
  }));
// console.log(myCart)
return myCart;

  // console.log(cartData);
  // console.log(productsData);
};



/**
 * Get the total value of all products added to the cart
 *
 * @param { Array.<CartItem> } items
 *    Array of objects with complete data on products added to the cart
 *
 * @returns { Number }
 *    Value of all items in the cart
 *
 */
export const getTotalCartValue = (items = []) => {
  // debugger;

  // if (!items.length)
  //   return 0;
  
  // const total = items.map((item) => item.qty).reduce((total, n) => total + n);
  // console.log(total);
  // return total;
  let totalCost=0;
  for (let i = 0; i < items.length; i++)
  {
    totalCost = totalCost + (items[i].cost * items[i].qty);
  }
  
  // console.log(totalCost);
  return totalCost;
 
  // return items.length ? items.reduce((total, item) => total + item.cost + item.qty, 0) : 0;
};

export const getTotalItems = (items = []) => {
  return items.length ? items.reduce((total, item) => total + item.qty, 0)
    : 0;
}


/**
 * Component to display the current quantity for a product and + and - buttons to update product quantity on cart
 * 
 * @param {Number} value
 *    Current quantity of product in cart
 * 
 * @param {Function} handleAdd
 *    Handler function which adds 1 more of a product to cart
 * 
 * @param {Function} handleDelete
 *    Handler function which reduces the quantity of a product in cart by 1
 * 
 * @param {Boolean} isReadOnly
 *    If product quantity on cart is to be displayed as read only without the + - options to change quantity
 * 
 */
const ItemQuantity = ({
  value,
  handleAdd,
  handleDelete,
  isReadOnly
}) => {
  if (isReadOnly)
  {
    return <Box>Qty: {value}</Box>
    }
  return (
    <Stack direction="row" alignItems="center">
      <IconButton size="small" color="primary" onClick={handleDelete}>
        <RemoveOutlined />
      </IconButton>
      <Box padding="0.5rem" data-testid="item-qty">
        {value}
      </Box>
      <IconButton size="small" color="primary" onClick={handleAdd}>
        <AddOutlined />
      </IconButton>
    </Stack>
  );
};

/**
 * Component to display the Cart view
 * 
 * @param { Array.<Product> } products
 * @param { Array.<Product> } products
 *    Array of objects with complete data of all available products
 * 
 * @param { Array.<Product> } items
 *    Array of objects with complete data on products in cart
 * 
 * @param {Function} handleDelete
 *    Current quantity of product in cart
 * 
 * @param {Boolean} isReadOnly
 *    If product quantity on cart is to be displayed as read only without the + - options to change quantity
 * 
 */
const Cart = ({
  products,
  items = [],
  handleQuantity,
  isReadOnly
}) => {

  const [productItem, setProductItem] = useState([]);
  const token = localStorage.getItem('token')
  const history = useHistory();
  // generateCartItemsFrom(products, items)
  // console.log(products)
  // console.log(items)

  const newCartData = generateCartItemsFrom(items, products)
  // console.log(newCartData)
  // useEffect(() => {
    // generateCartItemsFrom(items, products)
  // }, []);

  //very important code for rendering
  const displayCartItem = () =>
  {
    let temp = [];
    items.map((item) => {
      products.forEach((product) => { 
        if (item.productId === product._id)
        {
          
          temp.push({...product, ...item});
          
          }
      })
    })
    setProductItem(temp);
    // console.log(productItem)
    // const data = products.find((product) => item.productId === product._id)
    // setProductItem(data);
    // setProductItem(products.find((product) => item.productId === product._id ))
    // console.log(data);
    // return true;
  }

  useEffect(() => {
    // fetchVideosData();
    displayCartItem();
  }, [items]);

  //important logs
  // console.log(products);
  // console.log(items)
  if (!items.length) {
    return (
      <Box className="cart empty">
        <ShoppingCartOutlined className="empty-cart-icon" />
        <Box color="#aaa" textAlign="center">
          Cart is empty. Add more items to the cart to checkout.
        </Box>
      </Box>
    );
  }

  const doNone = () => {
    console.log("No deleting please");
  }

  const moveToCheckout = () => {
    
    history.push("/checkout", { from: "CartPage" })
  }

  const deleteRecord = (item) => {
    console.log("Item is zero")
  }

  let totalCost=0;

  return (
    <>
      <Box className="cart" >
        {/* TODO: CRIO_TASK_MODULE_CART - Display view for each cart item with non-zero quantity */}

        {
          newCartData.map((item) => {
        
          // {totalCost = totalCost+  item.cost * item.qty}
            // if (products.find((product) => item.productId === product._id))
            // {item.qty===0 ? deleteRecord(item): doNone()}
              return (
              <Box key={item._id} display="flex" alignItems="flex-start" padding="1rem">
                <Box className="image-container">
                    <img
                        // Add product image
                        src={item.image}
                        // Add product name as alt eext
                        alt=""
                        width="100%"
                        height="100%"
                    />
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    height="6rem"
                    paddingX="1rem"
                >
                    <div>{item.name/* Add product name */}</div>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                        <ItemQuantity
                        // Add required props by checking implementation
                        value={item.qty}
                        handleAdd={async () => {
                          await handleQuantity(
                            item._id,
                            item.qty + 1,
                            token,
                            items,
                            products
                            
                            
                          )
                        }}
                        handleDelete={async () => {
                          await handleQuantity(
                            item._id,
                            item.qty - 1,
                            token,
                            items,
                            products
                            
                          )
                        }}
                        isReadOnly={isReadOnly}
                        />
                        <Box padding="0.5rem" fontWeight="700">
                          ${item.cost /* Add product cost */}
                        </Box>
                    </Box>
                     
                  </Box>
                  
                  
                        {/* <p>Order total: { item.price}</p> */}
            
                </Box>
            )
          
            })
        }
        <Box
          padding="1rem"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box color="#3C3C3C" alignSelf="center" >
            Order Total
          </Box>
         {/* <p>Order total</p> */}
          <Box
            color="3C3C3C"
            fontWeight="700"
            fontSize="1.5rem"
            alignSelf="center"
            data-testid="cart-total" >
            ${getTotalCartValue(newCartData)}
            </Box>
          </Box>
        <Button className="button" variant="contained" alignItems="center" onClick={moveToCheckout}
            sx={{
              position: "relative",
              alignItems: "right",
              float: "right"
                }}
        >
          <AddShoppingCartOutlined />
          Checkout
        </Button>
        {/* <p>Order total: ${totalCost }</p> */}
        
      </Box>
    </>
  );
};

export default Cart;
